var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58936 4.73684C2.58936 4.19182 3.02734 3.75 3.56762 3.75H16.6111C17.1514 3.75 17.5894 4.19182 17.5894 4.73684C17.5894 5.28186 17.1514 5.72368 16.6111 5.72368H3.56762C3.02734 5.72368 2.58936 5.28186 2.58936 4.73684ZM2.58936 9.9997C2.58936 9.45468 3.02734 9.01286 3.56762 9.01286H16.6111C17.1514 9.01286 17.5894 9.45468 17.5894 9.9997C17.5894 10.5447 17.1514 10.9865 16.6111 10.9865H3.56762C3.02734 10.9865 2.58936 10.5447 2.58936 9.9997ZM3.56762 14.2764C3.02734 14.2764 2.58936 14.7182 2.58936 15.2632C2.58936 15.8083 3.02734 16.2501 3.56762 16.2501H16.6111C17.1514 16.2501 17.5894 15.8083 17.5894 15.2632C17.5894 14.7182 17.1514 14.2764 16.6111 14.2764H3.56762Z",
    fill: "#26B0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAll);
export default __webpack_public_path__ + "static/media/viewAll.9b174f118e98d722093fe5b57d408d2f.svg";
export { ForwardRef as ReactComponent };